var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74289_111979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8984 26.9562L60.9436 41.0021C64.6828 39.9627 69.0909 40.3232 72.5564 41.9132V8.6875L50.8984 26.9562Z",
    fill: "#D2DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3385 35.8639C38.577 37.3499 36.1269 37.3499 34.3653 35.8639L23.4678 26.6719L2.14844 57.8614H48.0118C48.0118 49.7863 53.4969 42.9934 60.9442 41.002L50.899 26.956L40.3385 35.8639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9168 57.8577C82.9168 67.4957 75.1036 75.3089 65.4656 75.3089C42.3416 74.4534 42.3479 41.2583 65.4658 40.4062C75.1036 40.4062 82.9168 48.2194 82.9168 57.8577Z",
    fill: "#1EB865"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14844 8.6875L34.367 35.864C36.1285 37.35 38.5786 37.35 40.3402 35.864L72.5585 8.6875H2.14844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14844 8.6875V57.8613H2.15009L23.4694 26.6718L2.14844 8.6875Z",
    fill: "#D2DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4694 26.6718L2.14844 8.6875V16.2627L20.185 31.4767L23.4694 26.6718Z",
    fill: "#93B2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8984 26.9562L54.2775 31.6811L72.5564 16.2627V8.6875L50.8984 26.9562Z",
    fill: "#93B2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3693 43.4391C36.1309 44.925 38.5809 44.925 40.3425 43.4391L54.2822 31.681L50.9029 26.956L40.3425 35.8639C38.5809 37.3499 36.1309 37.3499 34.3693 35.8639L23.4718 26.6719L20.1875 31.4767L34.3693 43.4391Z",
    fill: "#D2DCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14844 8.6875L34.367 35.864C36.1285 37.35 38.5786 37.35 40.3402 35.864L72.5585 8.6875H2.14844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3822 63.1886C62.9603 63.1886 62.5385 63.0278 62.2166 62.7059L59.0222 59.5114C57.5351 57.9107 59.7516 55.6929 61.3532 57.1802L63.3822 59.2091L69.5694 53.0218C70.2131 52.3781 71.2568 52.3781 71.9007 53.0218C72.5443 53.6655 72.5443 54.7092 71.9007 55.3529L64.5478 62.7057C64.2259 63.0276 63.8041 63.1886 63.3822 63.1886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2071 40.8837V8.68825C74.2041 8.52276 74.1832 8.35727 74.133 8.19887C73.9305 7.52355 73.2636 7.03367 72.5586 7.0401C72.4989 7.04307 2.14386 7.03433 2.0893 7.04307C1.22953 7.05592 0.482351 7.82668 0.500317 8.68842V57.8622C0.500317 58.7726 1.23827 59.5106 2.14864 59.5106H46.4372C47.2757 69.2732 55.4886 76.9618 65.4649 76.9618C85.5683 76.7029 91.7526 50.098 74.2071 40.8837ZM68.0481 10.3366L39.2775 34.6046C38.1268 35.5755 36.5805 35.5753 35.4299 34.6046L6.65926 10.3366H68.0481ZM3.79696 12.2351L33.3043 37.1247C34.4964 38.1302 35.925 38.6329 37.3536 38.6329C38.7822 38.6329 40.211 38.1302 41.403 37.1247L70.9104 12.2351V39.5497C59.3321 36.1188 47.487 44.1921 46.4358 56.2139H3.79696V12.2351ZM65.4649 73.665C56.751 73.665 49.6618 66.5759 49.6618 57.8621C50.4502 36.9365 80.4707 36.9215 81.2678 57.8622C81.268 66.5759 74.1787 73.665 65.4649 73.665Z",
    fill: "#3A2CA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74289_111979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCheck);
export default __webpack_public_path__ + "static/media/email-check.8e045597d47306a4bfba3b7e2f2577c5.svg";
export { ForwardRef as ReactComponent };